import React from 'react';
import { Link } from 'react-router-dom';
import { getOrgBadgeClass } from '../../lib/orgConfig';
import SpeakerImage from './SpeakerImage';
import SpeakerTopics from './SpeakerTopics';

const FeaturedSpeakerCard = ({ speaker, onClickTopic }) => {
  return (
    <Link
      to={`/speakers/${speaker.id}`}
      className="group relative block rounded-xl overflow-hidden shadow-md border border-gray-200 dark:border-gray-700 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
    >
      {/* Full-height image */}
      <div className="relative h-64">
        <SpeakerImage
          speaker={speaker}
          size="full"
          rounded=""
          className="absolute inset-0 w-full h-full"
        />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />

        {/* Featured badge */}
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 bg-secondary text-white text-xs font-bold rounded-full">
            ★ Featured
          </span>
        </div>

        {/* Info at bottom */}
        <div className="absolute bottom-0 left-0 right-0 p-5">
          {speaker.organization && (
            <span className={`inline-block px-2 py-1 text-xs font-medium rounded mb-2 ${getOrgBadgeClass(speaker.organization)}`}>
              {speaker.organization}
            </span>
          )}
          <h3 className="text-xl font-bold text-white">{speaker.name}</h3>
          {speaker.title && (
            <p className="text-white/80 text-sm">{speaker.title}</p>
          )}
          {speaker.church_name && (
            <p className="text-white/60 text-xs mt-1">{speaker.church_name}</p>
          )}
          {speaker.topics && speaker.topics.length > 0 && (
            <div className="mt-2">
              <SpeakerTopics topics={speaker.topics} max={3} onClickTopic={onClickTopic} />
            </div>
          )}
          {speaker.events_count > 0 && (
            <p className="text-white/70 text-xs mt-2">
              Speaking at {speaker.events_count} {speaker.events_count === 1 ? 'conference' : 'conferences'}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
};

export default FeaturedSpeakerCard;
